export const userRoleConsts = Object.freeze({
  admin: 'admin',
  tech: 'tech',
  serviceWriter: 'serviceWriter',
  super: 'super',
  onboarder: 'onboarder',
  engg: 'engg',
  sales: 'sales',
});
